module.exports = __webpack_public_path__ + "static/media/4-wedding-postponement_07_20-2020.7ce339e0.jpg";